// The one line that splits our two headers. A path is a "trip/guide" page (the
// immersive editor/viewer header) when it's a trip detail, guide editor, or a
// public trip share — anything else (home, explore, blog, dashboard, account,
// marketing) gets the plain header. Keep this the single source of truth so
// SiteHeader and any future caller never drift.
//
// The PUBLIC guide read view (`/guide/<slug>/<id>` with no `/edit`) is the
// exception: it's the editorial guidebook, a read-only public page where the
// EditorHeader's map/list toggle, undo/redo and publish controls don't belong —
// so it gets the plain Header. The owner's `/edit` view keeps EditorHeader.
// The id segment is a 36-char uuid in old links and a 10-char lowercase-alnum
// short id in new ones (see src/lib/short-id.ts) — match both forever.
const ID_SEGMENT = `(?:[a-f0-9-]{36}|[a-z0-9]{10})`
const TRIP_DETAIL = new RegExp(`/trip/[^/]+/${ID_SEGMENT}`)
const GUIDE_DETAIL = new RegExp(`/guide/[^/]+/${ID_SEGMENT}`)
const GUIDE_EDIT = new RegExp(`/guide/[^/]+/${ID_SEGMENT}/edit`)
const TRIP_SHARE = /\/trips?\/share\//

export function isTripOrGuidePage(pathname: string): boolean {
  // Guide read view → plain Header; guide editor → EditorHeader.
  if (GUIDE_DETAIL.test(pathname)) return GUIDE_EDIT.test(pathname)
  return TRIP_DETAIL.test(pathname) || TRIP_SHARE.test(pathname)
}
